/* 接口api集合 */
const prefix = '/rest/store/order/v3/';

// 【买卖车】
export const apiCart = {
  regionsSearch: prefix + 'regions/search', //区域查询
  carts: prefix + 'carts', //买卖车信息查询
  contract: prefix + 'carts/contract', //买卖车合同
  list: prefix + 'line-items/search', //买卖车列表
  submitOrder: prefix + 'carts/complete' //买入卖出下单
};

// 支付-收银台
export const apiGetPaymentBalances = '/rest/store/hub/v3/payment/balances'; // 查询商户和成员余额
export const apiGetAccountBalances = '/rest/store/hub/v3/payment/cardBalances'; // 查询账户卡余额
export const apiCheckAccountCard = '/rest/store/hub/v3/payment/cardCheck'; // 校验佣金账户支付卡信息
export const apiGetPaymentCardInfo = '/rest/store/hub/v3/payment/cardInfo'; // 查询芯钱包下的支付信息
export const apiGetCardDetail = '/nodeapi/hub-strapi/hub-cards/one/'; // 查询记账卡详情
export const apiRechargeMoney = '/rest/store/hub/v3/txRequest/recharge'; // 给卡充值
export const apiSetCardPassword = '/nodeapi/hub-strapi/hub-cards/password/'; // 设置支付卡的密码
export const apiSubmitPayment = `${prefix}orders/payment`; // 支付
export const apiAutoPayment = `${prefix}orders/offline-payment`; // 自动支付
export const apiGetPaymentFlow = `${prefix}orders/payment/search`; // 查询支付流水列表
export const apiGetPaymentDetail = `${prefix}orders/payment/`; // 查询支付流水详情

// 查询销售跟单、采购跟单列表
export const apiGetOrderBillList = `${prefix}orders/search`; // 入参match_type: S是销售跟单，P是采购跟单

// 查询销售跟单详情、采购跟单详情
export const apiGetBillDetail = `${prefix}orders/`;

// 查询销售跟项详情、采购跟项详情
export const apiGetItemDetail = `${prefix}line-items/`;

// 查询买入车、卖出车、销售跟项、采购跟项列表
// 入参match_type: S是销售跟项，P是采购跟项
// 入参cart_id是查询买入车、卖出车列表
// 入参order_id是查询页签中的销售跟项、采购跟项列表
export const apiGetOrderItemList = `${prefix}line-items/search`;

// 操作 销售跟单、采购跟单
export const apiEditBillDetail = `${prefix}orders`; // 编辑
export const apiCancelBill = `${prefix}orders/cancel-order`; // 取消
export const apiApprovalBill = `${prefix}orders/approve-order`; // 批准
export const apiReturnBill = `${prefix}orders/return-order`; // 退回

// 查询做单公司、货运、物流+财务联系人、收款银行、开票列表
export const apiCompanyAccountList = '/rest/store/account/v3/account/company_account/list'; // 做单公司列表
export const apiCompanyLogisticsList = '/rest/store/account/v3/account/company_logistics_address/list'; // 货运列表
export const apiCompanyContactList = '/rest/store/account/v3/contact/company_contact/list'; // 物流+财务联系人列表
export const apiCompanyBankList = '/rest/store/account/v3/account-bankinfo/company_bankinfo/list'; // 收款银行列表
export const apiCompanyTaxList = '/rest/store/account/v3/account-taxinfo/company_taxinfo/list'; // 开票列表

// 履约项
export const apiGetSendTakeList = `${prefix}fulfillment-items/search`; // 查询履约项列表
export const apiConfirmSendTakeItem = `${prefix}fulfillment-items/confirm`; // 确认履约项

// 查询销售退货列表、采购退货列表
export const apiGetReturnItemList = `${prefix}return-items/search`;

// 查询销售退货详情、采购退货详情
export const apiGetReturnItemDetail = `${prefix}return-items/`;

// 查询退货单详情
export const apiGetReturnBillDetail = `${prefix}return-orders/`;

// 查询退货原因列表
export const apiGetReturnReasonList = `${prefix}return-reasons/search`;

// 查询退货合同信息
export const apiGetReturnContract = `${prefix}return-orders/contract`;

// 提交售前变更申请
// 编辑销售跟项、编辑采购跟项
export const apiApplyBeforeChange = `${prefix}line-items`;

// 提交售后退货申请
export const apiApplyAfterChange = `${prefix}orders/return`;

// 售后退货前的校验
export const apiCheckAfterChange = `${prefix}orders/return/check`;

// 查询售前变更详情
export const apiGetBeforeChangeDetail = `${prefix}orders/order-edit`;

// 售前变更通过（同意售前变更）
export const apiAgreeBeforeChange = `${prefix}orders/order-edit/approve`;

// 售前变更驳回（拒绝售前变更）
export const apiRefuseBeforeChange = `${prefix}orders/order-edit/return`;

// 售后退货批准（同意售后退货）
export const apiAgreeAfterChange = `${prefix}return-orders/approve`;

// 售后退货退回（拒绝售后退货）
export const apiRefuseAfterChange = `${prefix}return-orders/return`;

// 销售退货详情入库接口
export const apiStorage = `${prefix}return-items/inventory`;

//
export const apiRepealReturn = `${prefix}return-orders/repeal-return`;

// 【详情页底部页签：附件】
export const apiDetailAttachment = {
  query: 'store/general/v3/attachments/query', // 列表
  upload: 'store/general/v3/attachments', // 上传
  update: 'store/general/v3/attachments', // 修改
  top: 'store/general/v3/attachments/top', // 置顶
  download: 'store/general/v3/attachments/download', // 下载
  delete: 'store/general/v3/attachments/' // 删除
};

// 【详情页底部页签：备注】
export const apiDetailNote = {
  get: `store/order/v3/notes/search`, // 列表
  set: `store/order/v3/notes` // 创建
};

// 【详情页底部页签：活动】
export const apiDetailActivity = {
  list: 'order/getErpActivityList', // 列表
  add: 'order/addErpActivity', // 创建
  detail: 'order/getErpActivityDetail' // 查看详情
};

// 业务域接口
export const apiGetCompanyList = '/rest/store/biz/v3/contract/department/accounts'; // 查询主体公司列表
export const apiGetShopMemberList = '/rest/store/contact/v3/contactshopmembers'; // 查询交易员列表
export const apiGetContactList = '/rest/store/biz/v3/contract/account/contacts'; // 查询联系人列表
export const apiGetTermList = '/rest/store/account/v3/accountPaymentTerm/search'; // 查询条款列表
export const apiGetShippingList = '/rest/store/biz/v3/contract/shippinginfos'; // 查询货运列表
export const apiGetBankList = '/rest/store/biz/v3/contract/bankinfos'; // 查询收款列表
export const apiGetTaxList = '/rest/store/biz/v3/contract/taxinfos'; // 查询开票列表

// 物流接口
export const apiGetWarehouseList = '/rest/portal/logistics/v3/warehouse/list'; // 查询仓库列表
export const apiGetQcRuleList = '/rest/portal/logistics/v3/qc_rule/list'; // 查询品控列表

export const tabApi = {
  attachment:apiDetailAttachment,
  // activity:apiDetailActivity,
  note:apiDetailNote
}
